import React, { useState } from "react";
import { Form, Card, Space, Row, Col, Dropdown, Pagination, message, Typography } from "antd";
import {
  faCloudArrowDown,
  faFilter,
  faTimes,
  faEye,
  faPen,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAllAssets,updateAsset } from "../../../Slices/assetSlice";
import { SERVER_URL } from "../../../databucket";
import { setLoader } from "../../../Slices/loaderSlice";
import axios from "axios";
import { AntdButton, DatePickerField, InputField } from "../../../blueplanitUtils/InputField";
import dayjs from "dayjs";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import AddMaintenanceModal from "./AddMaintenanceModal";
import ViewEditMaintenanceModal from "./View&EditMaintenanceModal";
import { S3ACCESSURL } from "../../../databucket";
import { setBtn } from "../../../Slices/employeeslice";


const { Title } = Typography;

const Maintenances = () => {
  const [filterForm] = Form.useForm();
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({});
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [maintenances, setMaintenances] = useState([]);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewingRecord, setViewingRecord] = useState(null);
  const filteredMaintenances= null;
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [selectedAssetTagId, setSelectedAssetTagId] = useState(null);
  const [originalEditingRecord, setOriginalEditingRecord] = useState(null);
  const AllAssets = useSelector((state) => state?.Assets?.allAssets)
  const dispatch = useDispatch();

  
  const assets = AllAssets?.records || [];

  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);

  const availableAssetIds = assets.filter(asset =>
    !maintenances?.some(m => m.assetTagId === asset.assetTagId)
  );

  const disable=useSelector((state)=>state.employee.button);
    useEffect(()=>{
      setTimeout(()=>{
        dispatch(setBtn(false))
      },3000)
    },[disable]);

  useEffect(() => {
    if (AllAssets) {
      const checkedOutAssets = AllAssets?.records?.filter(
        (asset) =>
          asset.checkInStatus === false ||
          asset.isManuallyAddedToMaintenance === true
      );
      const initialMaintenances = checkedOutAssets?.map((asset) => ({
        id: asset.id,
        productName: asset.productName,
        assetTagId: asset.assetTagId,
        checkedOutPerson: asset.checkedOutBy || null,
        reason: asset.checkOutReason || null,
        checkedOutDate: asset.checkOutDate || null,
        description: asset.description,
        maintenanceCost: asset.maintenanceCost || null,
        billPhoto: Array.isArray(asset.billPhoto) ? asset.billPhoto : [],
        expectedCheckInDate: asset.expectedCheckInDate || null,
        maintenanceHistory: asset.maintenanceHistory || [],
      }));
      setMaintenances(initialMaintenances);
    }
  }, [assets]);

  const columns = [
    {
      title: "Asset ID",
      dataIndex: "assetTagId",
      key: "assetTagId",
      align: "center",
    },
    {
      title: "Product Name",
      dataIndex: "productName",
      key: "productName",
      align: "center",
      render: (text) => text || "-",
    },
    {
      title: "Checked Out Person",
      dataIndex: "checkedOutPerson",
      key: "checkedOutPerson",
      render: (text) => text || "-",
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      align: "center",
      render: (text) => text || "-",
    },
    {
      title: "Checked Out Date",
      dataIndex: "checkedOutDate",
      key: "checkedOutDate",
      align: "center",
      render: (date) =>
        date ? dayjs(Number(date)).format("DD/MM/YYYY") : "-",
    },
    {
      title: "Product Details",
      dataIndex: "description",
      key: "description",
      align: "center",
      render: (text) => text || "-",
    },
    {
      title: "Maintenance Cost",
      dataIndex: "maintenanceCost",
      key: "maintenanceCost",
      align: "center",
      render: (value) =>
        value !== undefined && value !== null
          ? `₹ ${parseFloat(value).toFixed(0)}`
          : "-",
    },
    {
      title: "Maintenance Bill Photo",
      key: "billPhoto",
      align: "center",
      render: (_, record) => {
        const files = record.billPhoto;

        if (Array.isArray(files) && files.length > 0) {
          return (
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              {files.map((file, idx) => (
                <a key={idx} href={S3ACCESSURL+file.url} target="_blank" rel="noreferrer" style={{ color: "#1890ff" }}>
                  {file.originalName || `File ${idx + 1}`}
                </a>
              ))}
            </div>
          );
        } else {
          return "No File";
        }
      },
    },
    {
      title: "Expected Check-In Date",
      dataIndex: "expectedCheckInDate",
      key: "expectedCheckInDate",
      align: "center",
      render: (date) =>
        date ? dayjs(Number(date)).format("DD/MM/YYYY") : "-",
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Space>
          <AntdButton
            size="small"
            type="text"
            icon={
              <FontAwesomeIcon
                icon={faEye}
                style={{ fontSize: 16, color: "#1890ff" }}
              />
            }
            onClick={() => {
              setViewingRecord(record);
              setViewModalOpen(true);
            }}
          />
          <AntdButton
            icon={<FontAwesomeIcon icon={faPen} />}
            size="small"
            onClick={() => {
              setEditingRecord(record);
              setOriginalEditingRecord(record);
              setEditModalOpen(true);
            }}
          />
        </Space>
      ),
    }
  ];

  const exportHeaders = {
    assetTagId: "Asset ID",
    productName: "Product Name",
    reason: "Reason",
    checkedOutPerson: "Checked Out Person",
    description: "Product Details",
    maintenanceCost: "Maintenance Cost",
    billPhoto: "Bill Photo",
    checkedOutDate: "Checked Out Date",
    expectedCheckInDate: "Expected Check-In Date",
  };


  const handleUpdate = async () => {
    // Generate the changes array
    const fieldsToCompare = ["description", "maintenanceCost", "productName"];
    const changes = fieldsToCompare.reduce((acc, key) => {
      if (editingRecord[key] !== originalEditingRecord[key]) {
        acc.push({
          field: key,
          oldValue: originalEditingRecord[key],
          newValue: editingRecord[key],
        });
      }
      return acc;
    }, []);

    // Handle billPhoto separately
    if (
      JSON.stringify(editingRecord.billPhoto || []) !==
      JSON.stringify(originalEditingRecord?.billPhoto || [])
    ) {
      changes.push({
        field: "billPhoto",
        oldValue: originalEditingRecord?.billPhoto || [],
        newValue: editingRecord.billPhoto || [],
      });
    }

    // If no changes, show message
    if (changes.length === 0) {
      message.error({
        content: "No Change Detected to Update",
        duration: 2,
      });
      return false;
    }

    // Prepare sanitized billPhoto for backend
    const sanitizedBillPhoto = Array.isArray(editingRecord.billPhoto)
      ? editingRecord.billPhoto.map(({ originalName, mimeType, url }) => ({
          originalName,
          mimeType,
          url,
        }))
      : [];

    try {
      await dispatch(updateAsset({
        id: editingRecord.id,
        productName: editingRecord.productName,
        description: editingRecord.description,
        maintenanceCost: editingRecord.maintenanceCost,
        billPhoto: sanitizedBillPhoto,
        editedBy: `${loginUser?.firstname} ${loginUser?.lastname}`,
        editedAt: new Date().toISOString(),
        // changes,
      }));
      
      message.success("Maintenance record updated!");
      dispatch(getAllAssets({
        page: pagination.current,
        pageSize: pagination.pageSize,
        ...filters,
      }));
      setEditModalOpen(false);
      setEditingRecord(null);
    } catch (err) {
      message.error("Failed to update asset.");
    }
  };


  const handleExport = (fileFormat, selectedColumns, exportData) => {
    if (!exportData || exportData.length === 0) {
      message.info("No data available for export.");
      return;
    }

    const dataToExport = exportData.map((row) => {
      const formattedExpectedDate = row.expectedCheckInDate
        ? new Date(Number(row.expectedCheckInDate)).toLocaleDateString("en-IN")
        : "-";
      const formattedCheckedOutDate = row.checkedOutDate
        ? new Date(Number(row.checkedOutDate)).toLocaleDateString("en-IN")
        : "-";

      const formattedBillPhoto = Array.isArray(row.billPhoto)
        ? row.billPhoto.map((f) => f.originalName || "File").join(", ")
        : "-";

      return {
        assetTagId: row.assetTagId,
        productName: row.productName || "-",
        reason: row.reason || "-",
        checkedOutPerson: row.checkedOutPerson || "-",
        description: row.description || "-",
        maintenanceCost:
          row.maintenanceCost != null
            ? `Rs ${parseFloat(row.maintenanceCost).toFixed(0)}`
            : "-",
        billPhoto: formattedBillPhoto || "-",
        checkedOutDate: `${formattedCheckedOutDate}`,
        expectedCheckInDate: `${formattedExpectedDate}`,
      };
    });

    if (fileFormat === "CSV") {
      const csvData = convertToCSV(dataToExport, selectedColumns);
      downloadCSV(csvData, "Maintenances_Report.csv");
    } else if (fileFormat === "PDF") {
      simulatePrintDialog(dataToExport, selectedColumns);
    }
  };

  const convertToCSV = (data, selectedColumns) => {
    const headers = selectedColumns
      .map((col) => exportHeaders[col] || col)
      .join(",") + "\n";

    const rows = data.map((row) =>
      selectedColumns.map((col) => `"${row[col] ?? ""}"`).join(",")
    );
    return headers + rows.join("\n");
  };

  const downloadCSV = (csv, filename) => {
    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const simulatePrintDialog = (dataToExport, selectedColumns) => {
    const printableContent = document.createElement("div");
    printableContent.id = "print-content";

    const table = document.createElement("table");
    table.style.width = "100%";
    table.style.border = "1px solid #000";
    table.style.borderCollapse = "collapse";

    const thead = document.createElement("thead");
    const headerRow = document.createElement("tr");

    selectedColumns.forEach((col) => {
      const th = document.createElement("th");
      th.innerText = exportHeaders[col] || col;
      th.style.border = "1px solid #000";
      th.style.padding = "5px";
      th.style.backgroundColor = "#f0f0f0";
      headerRow.appendChild(th);
    });

    thead.appendChild(headerRow);
    table.appendChild(thead);

    const tbody = document.createElement("tbody");
    dataToExport.forEach((row) => {
      const tr = document.createElement("tr");

      selectedColumns.forEach((col) => {
        const td = document.createElement("td");
        td.style.border = "1px solid #ccc";
        td.style.padding = "5px";
        td.innerText = row[col] ?? "-";
        tr.appendChild(td);
      });

      tbody.appendChild(tr);
    });

    table.appendChild(tbody);
    printableContent.appendChild(table);

    const style = document.createElement("style");
    style.innerHTML = `
      body * { visibility: hidden; }
      #print-content, #print-content * { visibility: visible; }
      #print-content { position: absolute; top: 0; left: 0; width: 100%; }
      a { color: #1890ff; text-decoration: none; }
    `;
    document.head.appendChild(style);
    document.body.appendChild(printableContent);
    window.print();
    document.body.removeChild(printableContent);
    document.head.removeChild(style);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("files", file);

    try {
      dispatch(setLoader(true));
      const response = await axios.post(`${SERVER_URL}/upload`, formData);
      const uploadedFile = response.data.files?.[0];

      if (uploadedFile?.url) {

        const fileMeta = {
          originalName: uploadedFile.originalName || file.name,
          mimeType: uploadedFile.mimeType || file.type,
          url: uploadedFile.url,
        };
        setEditingRecord((prev) => ({
          ...prev,
          billPhoto: [fileMeta],
        }));
      } else {
        message.error("File upload failed.");
      }
    } catch (error) {
      message.error("File upload failed.");
    } finally {
      dispatch(setLoader(false));
    }
  };

  const handleSearch = (values) => {
     const filtered = Object.fromEntries(
      Object.entries(values).filter(([_, v]) => v !== undefined && v !== "")
    );
 
    if (Object.keys(filtered).length === 0) {
      message.error("Please select at least one filter");
      return;
    }
    const updatedFilters = {
      ...Object.fromEntries(
        Object.entries(values).filter(([_, v]) => v !== undefined && v !== "")
      ),
      checkOutDate: values.checkOutDate
        ? dayjs(values.checkOutDate).startOf("day").toISOString()
        : undefined,
      expectedCheckInDate: values.expectedCheckInDate
        ? dayjs(values.expectedCheckInDate).startOf("day").toISOString()
        : undefined,
    };

    setFilters(updatedFilters); // This triggers useEffect to refetch
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleClear = () => {
    filterForm.resetFields();
    setFilters({});
    dispatch(getAllAssets({ page: 1, pageSize: pagination.pageSize }));
  };

  useEffect(() => {
    dispatch(
      getAllAssets({
        page: pagination.current,
        pageSize: pagination.pageSize,
        ...filters,
      })
    );
  }, [filters, pagination.current]);


  return (
    <div style={{ padding: 24, marginTop: 20 }}>
      <Space style={{ marginBottom: 16, display: "flex", justifyContent: "center", alignItems: "center" }}>
      </Space>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginBottom: 8,
        }}
      >
        <AntdButton
          label="Filters"
          type="primary"
          onClick={() => setShowFilters((prev) => !prev)}
          icon={<FontAwesomeIcon icon={faFilter} />}
        />
        <AntdButton
          label="Add Maintenance"
          type="primary"
          onClick={() => setAddModalOpen(true)}
        />

        <Dropdown
          trigger={["click"]}
          menu={{
            items: [
              { key: "CSV", label: "Export as CSV" },
              { key: "PDF", label: "Export as PDF" },
            ],
            onClick: ({ key }) => {
              handleExport(
                key,
                Object.keys(exportHeaders),
                filteredMaintenances !== null ? filteredMaintenances : maintenances
              );
            },
          }}
        >
          <AntdButton label="Export" type="primary" icon={<FontAwesomeIcon icon={faCloudArrowDown} />} />
        </Dropdown>
      </div>
            <Title level={3} style={{ marginBottom: 10, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        List of Maintenances
      </Title>


      <Row gutter={30}>
        {showFilters && (
          <Col span={6} style={{ marginTop: "-125px" }}>
            <Card
              style={{
                backgroundColor: "#f9f9f9",
                borderRadius: 8,
                marginLeft: '-25px',
                marginTop:'-40px'
              }}
            >
              <FontAwesomeIcon
                icon={faTimes}
                onClick={() => setShowFilters(false)}
                style={{
                  position: "absolute",
                  top: 22,
                  right: 38, 
                  fontSize: 14,
                  cursor: "pointer",
                  color: "#999",
                }}
              />
              <div
                style={{
                  maxHeight: "calc(100vh - 160px)",
                  // overflowY: "auto",
                  paddingRight: 8,
                  marginTop: 10,
                  width:"250px"
                }}
              >
                <Form
                  layout="vertical"
                  form={filterForm}
                  onFinish={handleSearch}
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    marginTop: "10px",
                  }}
                >
                  <Row
                    gutter={[24, 0]}
                    style={{ height: "73vh", overflow: "auto" }}
                  >
                    <Col span={24}style={{ marginBottom: -20 }}>
                      <Form.Item name="assetTagId">
                        <InputField
                          label="Asset ID"
                          placeholder="Enter Asset ID"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}style={{ marginBottom: -20 }}>
                      <Form.Item name="productName">
                        <InputField
                          label="Product Name"
                          placeholder="Enter Product Name"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}style={{ marginBottom: -20 }}>
                      <Form.Item name="checkedOutBy">
                        <InputField
                          label="Checked Out Person"
                          placeholder="Enter person name"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}style={{ marginBottom: -20 }}>
                      <Form.Item name="checkOutDate">
                        <DatePickerField
                          label="Checked Out Date"
                          style={{ width: "100%"}}
                          format="DD/MM/YYYY"
                          placeholder="Select Checked Out Date"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}style={{ marginBottom: -10 }}>
                      <Form.Item name="maintenanceCost">
                        <InputField
                          label="Maintenance Cost"
                          type="number"
                          style={{ width: "100%"}}
                          placeholder="Enter Maintenance Cost"
                          min={0}
                          formatter={(value) =>
                            value !== undefined ? `₹ ${value}` : ""
                          }
                          parser={(value) => value?.replace(/[₹\s]/g, "")}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24}style={{ marginBottom: -20 }}>
                      <Form.Item name="expectedCheckInDate">
                        <DatePickerField
                          label="Expected Check-In Date"
                          style={{ width: "100%" }}
                          format="DD/MM/YYYY"
                          placeholder="Select Expected Check-In Date"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row
                    style={{
                      marginTop: "10px",
                      flex: 1,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Col span={24} style={{ textAlign: "center" }}>
                      <div
                        className="d-flex justify-content-end"
                        style={{ gap: "10px" }}
                      >
                        <AntdButton
                          label="Search"
                          htmlType="submit"
                          type="primary"
                          style={{ borderRadius: "10px" }}
                        />
                        <AntdButton
                          label="Clear"
                          onClick={handleClear}
                          style={{
                            backgroundColor: "#6c757d",
                            color: "#fff",
                            border: "none",
                            borderRadius: "10px",
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Card>
          </Col>
        )}

        <Col span={showFilters ? 18 : 24}>
          <CustomGridTable
            //loading={loading}
            columns={columns}
            Id="maintenances-list-table"
            dataSource={filteredMaintenances !== null ? filteredMaintenances : maintenances}
            pagination={false}
            bordered
            size="small"
            scroll={{ x: 1200 }}
            locale={{
              emptyText: "No maintenances available.",
            }}
            rowKey="id"
          />

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 16,
            }}
          >
            <Pagination
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={maintenances.length}
              onChange={(page) =>
                setPagination((prev) => ({
                  ...prev,
                  current: page,
                }))
              }
              showSizeChanger={false}
              size="small"
            />
          </div>
        </Col>

        <ViewEditMaintenanceModal
          editModalOpen={editModalOpen}
          viewModalOpen={viewModalOpen}
          editingRecord={editingRecord}
          originalEditingRecord={originalEditingRecord}
          viewingRecord={viewingRecord}
          onCloseEdit={() => {
            setEditModalOpen(false);
            setEditingRecord(null);
            setOriginalEditingRecord(null);
          }}
          onCloseView={() => {
            setViewingRecord(null);
            setViewModalOpen(false);
          }}
          onUpdate={handleUpdate}
          setEditingRecord={setEditingRecord}
          handleFileUpload={handleFileUpload}
        />

        <AddMaintenanceModal
          open={addModalOpen}
          onClose={() => {
            setAddModalOpen(false);

          }}
          onSuccess={() => {
            dispatch(getAllAssets({
              page: pagination.current,
              pageSize: pagination.pageSize,
              ...filters,
            }));
          }}
          assets={assets}
          availableAssetIds={availableAssetIds}
          selectedAssetTagId={selectedAssetTagId}
          setSelectedAssetTagId={setSelectedAssetTagId}
        />
      </Row>
    </div>
  );
};

export default Maintenances;
